import { render, staticRenderFns } from "./SnapshotTable.vue?vue&type=template&id=6156fc53&scoped=true&"
import script from "./SnapshotTable.vue?vue&type=script&lang=js&"
export * from "./SnapshotTable.vue?vue&type=script&lang=js&"
import style0 from "./SnapshotTable.vue?vue&type=style&index=0&id=6156fc53&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6156fc53",
  null
  
)

export default component.exports